import FloatingCalculator from './FloatingCalculator'

export default FloatingCalculator
